import React, { useEffect, useState } from "react";
import { Loader } from "../../common/Loader";
import {
  getAllBoards,
  getBoardIdsInRedis,
  syncLatestChartData,
  updateBoardIdsInRedis,
} from "../../apiservice/ApiService";
import { Button, Select } from "antd";
import { toast } from "react-toastify";

const ChartSettings = () => {
  const [loading, setLoading] = useState(false);
  const [allBoardId, setAllBoardId] = useState([]);
  const [selectedBoards, setSelectedBoards] = useState([]);

  const getListOfAllBoards = async () => {
    setLoading(true);
    let tempBoardIds = [];
    try {
      const response = await getAllBoards();
      if (response.success) {
        response.data.response.boards.forEach((item) => {
          tempBoardIds.push({ label: item.name, value: item.id });
        });

        setAllBoardId(tempBoardIds);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getSelectedBoards = async () => {
    try {
      const response = await getBoardIdsInRedis();
      // console.log("response", response);
      if (response.success) {
        setSelectedBoards(response.data.data);
      } else {
        setSelectedBoards([]);
      }
    } catch (error) {
      
    }
  }

  const fetchAllRequest = async () => {
    setLoading(true);
    await getListOfAllBoards();
    await getSelectedBoards();
    setLoading(false);
  }

  const handleSave = async () => {
    setLoading(true);
    let payload = JSON.stringify({
      board_ids: selectedBoards,
    });
    try {
      const response = await updateBoardIdsInRedis(payload);
      console.log("response", response);
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error("Failed to update Board IDs");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const syncLatestChart = async () => {
    // setLoading(true);
    toast.success("Syncing Started, it will take some time to complete");
    try {
      const response = await syncLatestChartData();
    } catch (error) {
      console.error("Error synchronizing chart data");
    } 
  };

  const filterOption = (input, option) => {
    return (
      option.label.toLowerCase().includes(input.toLowerCase()) ||
      option.value.toString().toLowerCase().includes(input.toLowerCase())
    );
  };

  useEffect(() => {
    fetchAllRequest();
  }, []);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <>
      {loading && <Loader />}
      <h4 style={{ textAlign: "left" }}>Chart Settings</h4>
      <p style={{ textAlign: "left" }}>
        Select the board Id containing the highest number of items:
      </p>
      <div className="col-12 row mt-3">
        <div className="col-sm-7">
          <Select
            mode="multiple"
            options={allBoardId}
            style={{ width: "100%" }}
            placeholder="Select boards"
            filterOption={filterOption}
            value={selectedBoards}
            onChange={(value) => setSelectedBoards(value)}
          />

          <small className="text-danger text-start ms-2"></small>
        </div>
        <div className="col-sm-5 display-flex justify-content-space-between align-items-center">
          <Button
            style={{
              background: "#487ed8",
              color: "white",
              border: "none",
            }}
            onClick={() => handleSave()}
          >
            SAVE
          </Button>{" "}
          <Button
            style={{
              background: "#487ed8",
              color: "white",
              border: "none",
            }}
            onClick={() => syncLatestChart()}
          >
            Synchronize the latest chart data
          </Button>
        </div>
      </div>
    </>
  );
};

export default ChartSettings;
